import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const AlmacenGestionar = () => {
    
    return (
        <Typography variant='h6' component='h1'>
            Gestionar Almacen
        </Typography>
    )
}

export default AlmacenGestionar
